// ProductoPicker - S47.3a.
// Selector de UN producto para vincular al preview del editor de etiquetas.
// Usa useProductosEtiquetaXL (wrapper read-only). Si la lista esta cargando,
// muestra estado de carga; si hay error, muestra el error; si esta vacia,
// muestra hint. Al elegir un producto, emite onChange(productoId|null).
import { useEffect, useMemo } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLSelect from '../../../components/xl/XLSelect';
import useProductosEtiquetaXL from '../hooks/useProductosEtiquetaXL';

const CSS_ID = 'xl-et-prodpicker-css';
const CSS = `
.xl-et-prodpicker { display: inline-flex; flex-direction: column; gap: 4px; min-width: 280px }
.xl-et-prodpicker__hint {
  font: 500 11px/1.4 var(--xl-font-sans);
  color: var(--xl-color-text-muted);
}
.xl-et-prodpicker__err {
  font: 500 11px/1.4 var(--xl-font-sans);
  color: var(--xl-color-danger);
}
`;

export default function ProductoPicker({ value, onChange }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const { items, loading, error } = useProductosEtiquetaXL();

  const options = useMemo(() => {
    const opts = [{ value: '', label: '(Sin producto / valores demo)' }];
    items.forEach((p) => {
      const lbl = (p.codigo ? p.codigo + ' - ' : '') + (p.nombre || '');
      opts.push({ value: String(p.id), label: lbl });
    });
    return opts;
  }, [items]);

  const handle = (e) => {
    const v = e.target.value;
    if (typeof onChange === 'function') {
      onChange(v ? Number(v) : null);
    }
  };

  const hint = loading
    ? 'Cargando productos...'
    : 'Producto vinculado al preview';

  return (
    <label className="xl-et-prodpicker">
      <span className="xl-et-prodpicker__hint">Producto</span>
      <XLSelect
        value={value == null ? '' : String(value)}
        onChange={handle}
        options={options}
        ariaLabel="Producto vinculado"
        disabled={loading}
      />
      {error ? (
        <span className="xl-et-prodpicker__err">{String(error)}</span>
      ) : (
        <span className="xl-et-prodpicker__hint">{hint}</span>
      )}
    </label>
  );
}
